import * as React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

export default function IconLabelButtons({
	btnVariant,
	isIcon,
	Icon,
	iconPosition,
	btnLabel,
	btnAction,
}) {
	const theme = useTheme();
	// Determine the icon prop based on the iconPosition value
	const iconProps =
		isIcon &&
		(iconPosition.toLowerCase() === "start" ? { startIcon: <Icon /> } : { endIcon: <Icon /> });

	return (
		<Button
			variant={btnVariant}
			onClick={btnAction}
			{...(isIcon ? iconProps : {})} // Spread iconProps only if isIcon is true
			sx={{
				textTransform: "none",
				fontFamily: "Poppins, sans-serif",
				color: theme.palette.text.buttonhover,
				backgroundColor: theme.palette.button.main,
				height: "40px",
				"&:hover": {
					backgroundColor: theme.palette.buttonhover.main,
				},
			}}
		>
			{btnLabel}
		</Button>
	);
}
